import { addData, cloneElement, wrapWithGroup } from '../constructionTools';

export function createObjectInstance(object, wall, elementPrototypes) {
  let prototype = elementPrototypes[object.variant || object.type];
  if (prototype instanceof Function) {
    prototype = prototype(object, wall);
  }
  if (!prototype) {
    console.error('No prototype found for the following object', object);
    return;
  }

  const element = cloneElement(prototype, { cloneMaterial: true });

  addData(element, { ...object, editable: true });
  element.warehouseObjectRef = object;
  element.wall = wall;
  element.collisions = true;
  return element;
}

export function addObjectToSegmentBase(walls, object, elementPrototypes) {
  const wall = walls[object.side];

  const element = createObjectInstance(object, wall, elementPrototypes);

  element.position.x = object.centerOffsetX;
  if (object.centerOffsetY && !isNaN(object.centerOffsetY)) {
    element.position.y = object.centerOffsetY;
  }
  const segment = wrapWithGroup(wall.children[object.index]);
  segment.add(element);
  element.wallSegment = segment;
  return {
    element,
    segment,
  };
}

export function addObjectToWallBase(walls, object, elementPrototypes) {
  const wall = walls[object.side];

  const element = createObjectInstance(object, wall, elementPrototypes);

  // using leftOffsetX makes absolutely positioned elements stick to their place when size changes
  if (object.leftOffsetX) {
    element.position.x = object.leftOffsetX - wall.userData.length * 0.5;
  } else {
    element.position.x = object.centerOffsetX;
  }
  if (object.centerOffsetY && !isNaN(object.centerOffsetY)) {
    element.position.y = object.centerOffsetY;
  }
  wall.add(element);

  return {
    element,
    wall,
  };
}
